import React from 'react';
import { formatCurrencySigFig } from '../../utils/formatters';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';
import './RecreationalCard.css';

interface RecreationalCardData {
  year?: string;
  fishingExpenditure?: number;
}

export default function RecreationalCard(props: RegistryComponentProps): React.ReactElement {
  const pageData = usePageDataContextOptional();
  const injectionData = getRegistryData<RecreationalCardData>(props);

  // Prefer PageDataContext fisheryStats when available, else use injections
  const fisheryStats = (pageData?.data?.fisheryStats as RecreationalCardData | undefined) ?? injectionData;
  const { year, fishingExpenditure } = fisheryStats;

  return (
    <div className="recreational-card">
      <div className="recreational-card__title-row">
        <h3 className="recreational-card__title">Recreational {year && `(${year})`}</h3>
      </div>
      <div className="recreational-card__columns">
        <div className="recreational-card__column">
          <div className="recreational-card__metric">
            <span className="recreational-card__label">Fishing Expenditure</span>
            <span className="recreational-card__value">{formatCurrencySigFig(fishingExpenditure)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
